<template>
<div
  :class="{
    'input-with-label': (inputType && inputType.toLowerCase() === 'text') || inputType.toLowerCase() === 'password',
    'textarea-with-label': inputType && inputType.toLowerCase() === 'textarea',
    'variable-textarea-with-label': inputType && inputType.toLowerCase() === 'variabletextarea',
  }"
>
  <label :for="`${label.toLowerCase()}`">{{ label }}</label>
  <input
    :disabled="disabled"
    v-if="inputType && inputType.toLowerCase() === 'text'"
    class="input"
    :value="value"
    @change="onChange"
    @input="onChange"
    :name="`${label.toLowerCase()}`"
    type="text"
    required
    autocomplete="off"
  />
  <input
    :disabled="disabled"
    v-if="inputType && inputType.toLowerCase() === 'password'"
    class="input"
    :value="value"
    @change="onChange"
    :name="`${label.toLowerCase()}`"
    type="password"
    required
    autocomplete="off"
  />
  <textAreaResize>
    <textarea
      :disabled="disabled"
      v-if="(inputType && inputType.toLowerCase() === 'textarea') || (inputType && inputType.toLowerCase() === 'variabletextarea')"
      class="inputArea"
      :value="value"
      @change="onChange"
      type="textarea"
      :name="`${label.toLowerCase()}`"
      required
      autocomplete="off"
    />
  </textAreaResize>
</div>
</template>

<script>
import textAreaResize from 'text-area-resize';

export default {
  name: 'base-input-with-label',
  components: {
    textAreaResize,
  },
  props: {
    label: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    value: {
      type: [String, Number],
    },
    inputType: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },
  data: function() {
    return {};
  },
  methods: {
    onChange($event) {
      this.$emit('baseInputChanged', $event);
    },
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

$trans-time: 300ms;
$width: 100%;

.input-with-label {
  label {
    display: block;
    font-size: 1.7rem;
    margin-bottom: 1rem;
  }
  input {
    border: 1px solid $color-input-border;
    border-radius: $size-input-border-radius;
    box-sizing: border-box;
    font-size: 1.7rem;
    margin-bottom: 1.6rem;
    padding: 0.8rem;
    width: 100%;
    &:active,
    &:focus {
      border: 2px solid $color-action;
      margin-bottom: 1.4rem;
      outline: none;
    }
  }
}
</style>
